import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "../data/content";

const TimelineItem = ({ item, index }) => {
  return (
    <div className="relative pl-16 sm:pl-24 pb-16 last:pb-0" data-testid={`process-step-${item.step}`}>
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="absolute left-0 top-0 flex h-12 w-12 sm:h-16 sm:w-16 items-center justify-center rounded-full border-2 border-gold bg-white shadow-[0_0_0_6px_rgba(197,160,89,0.12)]"
      >
        <span className="font-display font-bold text-gold text-sm sm:text-base">{item.step}</span>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
      >
        <h3 className="font-display text-2xl sm:text-3xl font-medium text-forest">{item.title}</h3>
        <p className="mt-3 max-w-xl text-lg text-charcoal/60 leading-relaxed">{item.text}</p>
      </motion.div>
    </div>
  );
};

export const ProcessTimeline = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start center", "end center"],
  });
  const height = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <div ref={ref} className="relative">
      <div className="absolute left-6 sm:left-8 top-6 bottom-6 w-[2px] bg-border" />
      <motion.div
        style={{ height }}
        className="absolute left-6 sm:left-8 top-6 w-[2px] bg-gradient-to-b from-gold to-forest"
      />
      <div>
        {PROCESS.map((item, i) => (
          <TimelineItem key={item.step} item={item} index={i} />
        ))}
      </div>
    </div>
  );
};
